
import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import config from "../config";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [restaurant, setRestaurant] = useState("");

  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");



  const handleLogin = async () => {
    if (!email || !password || !restaurant) {
      setError("All fields are required");
    } else {
      try {
        setLoading(true);
        await login({
          username: email,
          password,
          restaurantName: restaurant
        });
        setLoading(false);
      } catch (err) {
        console.error("Login error:", err);
        setError("Invalid credentials");
        setLoading(false);
      }
    }


  };

  useEffect(() => {
    console.log("Login user state:", user);
    if (user) {
      if (user.role === config.USER_SUPERADMIN) {
        navigate("/admin");
      } else if (user.role === config.USER_MANAGER) {
        navigate("/dashboard");
      } else {
        navigate("/dashboard");
      }
    }
  }, [user, navigate]);


  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">

      <div className="bg-white rounded-2xl shadow-2xl p-8 w-80">

        {/* Title */}
        <h2 className="text-2xl font-bold text-center text-gray-800">
          Welcome Back 👋
        </h2>

        <p className="text-gray-500 text-center mt-2 mb-6">
          Login to your account
        </p>

        {/* Input */}
        <input
          type="email"
          placeholder="Enter email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full px-4 py-2 mb-3 border border-gray-300 rounded-lg 
                     focus:outline-none focus:ring-2 focus:ring-indigo-400 
                     transition"
        />

        <input
          type="password"
          placeholder="Enter password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full px-4 py-2 mb-3 border border-gray-300 rounded-lg 
                     focus:outline-none focus:ring-2 focus:ring-indigo-400 
                     transition"
        />

        <select
          value={restaurant}
          onChange={(e) => setRestaurant(e.target.value)}
          className="w-full px-4 py-2 mb-3 border border-gray-300 rounded-lg 
                     focus:outline-none focus:ring-2 focus:ring-indigo-400 
                     transition"
        >
          <option value="">Select a restaurant</option>
          <option value="AtithiDhabaAirport">AtithiDhabaAirport</option>
          <option value="AtithiDhabaGangwal">AtithiDhabaGangwal</option>
          <option value="AtithiDhabaMR5">AtithiDhabaMR5</option>
          <option value="AtithiDhabaVijayNagar">AtithiDhabaVijayNagar</option>
        </select>

        {/* Button */}
        <button
          onClick={handleLogin}
          className="w-full bg-indigo-500 text-white py-2 rounded-lg 
                     hover:bg-indigo-600 transition duration-300 font-semibold"
        >
          {loading ? "Logging in..." : "Login"}
        </button>
        {error && <p className="text-red-500 text-center mt-2">{error}</p>}


        {/* Demo users info (optional but useful) */}
        <p className="text-xs text-gray-400 text-center mt-4">
          Try: admin@test.com or user@test.com
        </p>

      </div>
    </div>
  );
}
